
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

class ContactusApi {

    static async create(message: string, sender_email: string) {

        try {
            const response = await fetch(`${API_BASE_URL}/contact_us`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({contact_us:{
                    message: message,
                    sender_email: sender_email}
                }),
            });



            const responseBody = await response.json();


            if (response.status < 300) {
                //console.log('account api---', responseBody);
                return responseBody;
            }
            else {
                throw new Error(`${responseBody.error} status ${response.status}`);
            }
        } catch (error) {
            if (error instanceof Error) {
                throw new Error(`Failed to send contact us meaage: ${error.message}`);
            } else {
                throw new Error('Failed to send contact us meaage: An unknown error occurred.');
            }
        }
    }
}

export default ContactusApi;